import { observer } from 'mobx-react-lite';
import { withDefaultProps } from 'react-default-props-context';
import { BackwardArrowIcon } from 'src/frames/icons/BackwardArrowIcon';
import { cn } from 'src/frames/utils/cn';
import './BackButton.scss';

type PropsT = {
  className?: any;
  onClick?: Function;
};

type DefaultPropsT = {
  rollBackToPreviousPage: () => void;
};

export const BackButton = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    return (
      <div className={cn('BackButton', props.className)}>
        <button
          onClick={() => (props.onClick ?? props.rollBackToPreviousPage)()}
        >
          <BackwardArrowIcon />
        </button>
      </div>
    );
  })
);
